// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__29SLu","label":"Section_label__3KM6U","contentWrap":"Section_contentWrap__3yxIs","footer":"Section_footer__1UCz8","footerInner":"Section_footerInner__toNyO"};